import { NativeDateAdapter, DateAdapter, MAT_DATE_FORMATS } from "@angular/material";

export function getAcademyDateFormat(): string {
  return sessionStorage.getItem("date_format") || "d/m/Y";
}

export function parseAcademyDate(value: any): Date | null {
  if (value == null || value === "") {
    return null;
  }
  if (value instanceof Date && !isNaN(value.getTime())) {
    return value;
  }

  const str = String(value).trim();
  const dateFormat = getAcademyDateFormat();
  const separator = str.indexOf("-") > -1 ? "-" : "/";
  const parts = str.split(separator);

  if (parts.length !== 3) {
    const fallback = new Date(value);
    return isNaN(fallback.getTime()) ? null : fallback;
  }

  let day: number;
  let month: number;
  let year: number;

  if (dateFormat === "Y-m-d" || dateFormat === "Y/m/d") {
    year = parseInt(parts[0], 10);
    month = parseInt(parts[1], 10);
    day = parseInt(parts[2], 10);
  } else if (dateFormat === "d-m-Y" || dateFormat === "d/m/Y") {
    day = parseInt(parts[0], 10);
    month = parseInt(parts[1], 10);
    year = parseInt(parts[2], 10);
  } else if (dateFormat === "m/d/Y") {
    month = parseInt(parts[0], 10);
    day = parseInt(parts[1], 10);
    year = parseInt(parts[2], 10);
  } else {
    day = parseInt(parts[0], 10);
    month = parseInt(parts[1], 10);
    year = parseInt(parts[2], 10);
  }

  if (isNaN(day) || isNaN(month) || isNaN(year)) {
    return null;
  }

  const parsed = new Date(year, month - 1, day);
  return isNaN(parsed.getTime()) ? null : parsed;
}

export function formatAcademyDate(date: Date): string {
  const dateFormat = getAcademyDateFormat();
  let day: any = date.getDate();
  let month: any = date.getMonth() + 1;
  const year = date.getFullYear();

  if (day < 10) {
    day = "0" + day;
  }
  if (month < 10) {
    month = "0" + month;
  }

  if (dateFormat === "Y-m-d") {
    return `${year}-${month}-${day}`;
  }
  if (dateFormat === "d-m-Y") {
    return `${day}-${month}-${year}`;
  }
  if (dateFormat === "Y/m/d") {
    return `${year}/${month}/${day}`;
  }
  if (dateFormat === "d/m/Y") {
    return `${day}/${month}/${year}`;
  }
  if (dateFormat === "m/d/Y") {
    return `${month}/${day}/${year}`;
  }

  return `${day}/${month}/${year}`;
}

function to2digit(n: number): string {
  return ("00" + n).slice(-2);
}

export class AppDateAdapter extends NativeDateAdapter {
  format(date: Date, displayFormat: Object): string {
    const dateFormat = getAcademyDateFormat();

    if (displayFormat === "input") {
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const year = date.getFullYear();

      if (dateFormat === "Y-m-d") {
        return year + "-" + to2digit(month) + "-" + to2digit(day);
      } else if (dateFormat === "d-m-Y") {
        return to2digit(day) + "-" + to2digit(month) + "-" + year;
      } else if (dateFormat === "Y/m/d") {
        return year + "/" + to2digit(month) + "/" + to2digit(day);
      } else if (dateFormat === "d/m/Y") {
        return to2digit(day) + "/" + to2digit(month) + "/" + year;
      } else if (dateFormat === "m/d/Y") {
        return to2digit(month) + "/" + to2digit(day) + "/" + year;
      }

      return to2digit(day) + "/" + to2digit(month) + "/" + year;
    }

    return date.toDateString();
  }

  parse(value: any): Date | null {
    if (typeof value === "number") {
      return new Date(value);
    }
    return parseAcademyDate(value);
  }
}

export const APP_DATE_FORMATS = {
  parse: {
    dateInput: { month: "short", year: "numeric", day: "numeric" }
  },
  display: {
    dateInput: "input",
    monthYearLabel: { month: "short", year: "numeric", day: "numeric" },
    dateA11yLabel: { year: "numeric", month: "long", day: "numeric" },
    monthYearA11yLabel: { year: "numeric", month: "long" }
  }
};
